"use client";
import { n as useOptimisticAction, r as useStateAction, t as useAction } from "./hooks-RMagaUHm.mjs";
export { useAction, useOptimisticAction, useStateAction };
